/**
 * shots.js — capturas de la app real usadas por la Academia.
 *
 * Viven en `src/academy/img/` y se importan (no en `public/`) porque el
 * contenedor de desarrollo sólo monta `frontend/src`: una imagen en `public/`
 * no se vería hasta reconstruir la imagen. Con el import, webpack la sirve
 * igual en desarrollo y en producción.
 *
 * Para rehacer una captura: mismo nombre de archivo, misma ruta. Ver
 * docs/ACADEMIA_CMDB.md §6.
 */

import menuBase from './img/menu/01-menu.png';
import menuSecciones from './img/menu/02-secciones.png';
import menuFavoritoDialogo from './img/menu/03-favoritos.png';
import menuFavoritos from './img/menu/04-favoritos-menu.png';
import menuPersonalizar from './img/menu/05-personalizar.png';
import menuOcultar from './img/menu/06-ocultar.png';
import racksListado from './img/racks/01-listado.png';
import racksFicha from './img/racks/02-ficha.png';
import racksDisenador from './img/racks/03-disenador.png';
import listadosColumnas from './img/listados/01-columnas.png';
import perfilAspecto from './img/perfil/01-aspecto.png';
import perfilIdioma from './img/perfil/02-idioma.png';

export const SHOTS = {
  'menu/01-menu.png': menuBase,
  'menu/02-secciones.png': menuSecciones,
  'menu/03-favoritos.png': menuFavoritoDialogo,
  'menu/04-favoritos-menu.png': menuFavoritos,
  'menu/05-personalizar.png': menuPersonalizar,
  'menu/06-ocultar.png': menuOcultar,
  'racks/01-listado.png': racksListado,
  'racks/02-ficha.png': racksFicha,
  'racks/03-disenador.png': racksDisenador,
  'listados/01-columnas.png': listadosColumnas,
  'perfil/01-aspecto.png': perfilAspecto,
  'perfil/02-idioma.png': perfilIdioma,
};

/** Ruta importada de una captura (o la propia ruta si no está registrada). */
export function resolveShot(src) {
  return SHOTS[src] || src;
}
